module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/darkThemeImage-f5f70b5962542f235a8aad6bc10cb3de.png";